import Model from "~/models/_Model";

export default class Setting extends Model {
  // Set the resource route of the model
  resource() {
    return "settings";
  }
}
